import { BaseEnum } from "../../../enums/baseEnum";

const recruitmentCandidateStatuses: Array<RecruitmentCandidateStatus> = [];

export class RecruitmentCandidateStatus extends BaseEnum {
  static IN_PROGRESS = new RecruitmentCandidateStatus(1, "InProgress", "Em andamento", "warning");
  static HIRED = new RecruitmentCandidateStatus(2, "Hired", "Contratado(a)", "success");
  static REJECTED = new RecruitmentCandidateStatus(3, "Rejected", "Reprovado", "danger");
  static DISABLED = new RecruitmentCandidateStatus(4, "Disabled", "Desativado(a)", "secondary");
  static REASSIGNED = new RecruitmentCandidateStatus(5, "Reassigned", "Remanejado", "secondary");
  static WITHDRAWN = new RecruitmentCandidateStatus(6, "Withdrawn", "Desistiu", "warning");

  constructor(public id: number, public value: string, public label: string, public className: string) {
    super(id, value, label, className);
    recruitmentCandidateStatuses.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return recruitmentCandidateStatuses;
  }

  public static getById(id: number): RecruitmentCandidateStatus {
    return recruitmentCandidateStatuses.find((item) => item.id === id) as RecruitmentCandidateStatus;
  }

  public static getBy(value: string): RecruitmentCandidateStatus {
    return recruitmentCandidateStatuses.find((item) => item.value === value) as RecruitmentCandidateStatus;
  }
}
